"use client";

import { c as _c } from "react/compiler-runtime";
import JobAdVideo from "~/components/job-page/jobadvideo/jobad-video-eon";
import type { Job } from "~/types/job";
interface CompanyEconProps {
  job: Job;
}
export default function CompanyEcon(t0) {
  const $ = _c(10);
  const {
    job
  } = t0;
  if (!job) {
    return null;
  }
  let t1;
  if ($[0] !== job.data.company) {
    t1 = <h2 className="mb-10 font-bold text-4xl xl:text-5xl">{job.data.company}</h2>;
    $[0] = job.data.company;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== job.content.business) {
    t2 = <div className="gap-20 text-lg [&>p]:mb-4" dangerouslySetInnerHTML={{
      __html: job.content.business
    }} />;
    $[2] = job.content.business;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <JobAdVideo buttonColor="bg-accent" thumbnailSrc="images/videos/econ/company_video_thumbnail.webp" videoUrl="/econ/Imagefilm_16zu9_MIT subtitle.mp4" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="grid auto-cols-fr gap-x-8 gap-y-8 lg:grid-flow-col xl:gap-x-12">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <section className="outer-container bg-linear-to-br from-[#ea1b0a] to-[#00375c] py-container text-white print:hidden" id="company"><div className="inner-container">{t1}{t4}</div></section>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}